/**
 * Pure H OS · Phase D Wave 2 · PMO (types + live view).
 * MongoDB collection: `pureh_pmo_projects`.
 */
import { liveArray } from "../services/store";

export type PmoPhase = "kickoff" | "discovery" | "delivery" | "launch" | "closed";
export type PmoHealth = "green" | "amber" | "red";

export type PmoProject = {
  id: string;
  name: string;
  sponsor: string;
  lead: string;
  phase: PmoPhase;
  progressPct: number;
  startedRelative: string;
  dueRelative: string;
  health: PmoHealth;
  budgetEGP: number;
  spendEGP: number;
  milestones: number;
  milestonesDone: number;
  risks: number;
};

export const PMO_PROJECTS: PmoProject[] = liveArray<PmoProject>("pmo_projects");
